import React from "react";

function Styling() {
    return (
        <p>this is the styling project page</p>
    )
}

export default Styling